import React, { Component } from "react";
import PropTypes from "prop-types";
import WithDependencies from "./WithDependencies";
import dom from "../../utils/dom.js";
import * as helpers from "../../utils/enhancementsHelper";
import g from "../../utils/globals";

class UpdatesLayout extends Component {
  componentWillMount() {
    const html = document.querySelector("html");
    // FOLD MENU
    // LEGACY CODE
    if (/-ULTIMASEMANA-/.test(html.id)) {
      if (g.channels.mobile || g.isTablet) {
        helpers.foldMenu();
      }
    } else if (/-EDITORIALS-|-CAMPANA-|-CAMPAIGN-|-STORIES-/.test(html.id)) {
      helpers.foldMenu();
    }
    // NEW FOLDMENU
    if (this.props.customProps) {
      if (this.props.customProps.foldMenu) {
        helpers.foldMenu();
      } else if (this.props.customProps.foldMenu === false) {
        helpers.unfoldMenu();
      }
    }

    // FULLSCREEN
    if (this.props.fullscreen) {
      dom.addBodyClass("fullscreen");
    }
    // OTHER CLASSES
    if (!this.props.carousel && this.props.bodyClassName) {
      dom.addBodyClass(this.props.bodyClassName);
    }
  }

  componentWillUnmount() {
    if (this.props.bodyClassName) {
      dom.removeBodyClass(this.props.bodyClassName);
    }
  }

  render() {
    return <WithDependencies {...this.props} />;
  }
}

UpdatesLayout.propTypes = {
  contents: PropTypes.array,
};

export default UpdatesLayout;
